var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-overlay",class:{ 'is-visible': _vm.visible },on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.spinner)?_c('cs-spinner',{staticClass:"is-white"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }